module.exports = __webpack_public_path__ + "static/img/demand02.ab219f9a.png";